import { get, post, put, del } from '@api/request';

export async function fetchEquityConfigAll(
  { appraisalService },
  authenticationToken,
  { type },
) {
  let url = `${appraisalService}/appraisal/comparableequity/configuration`;
  if (type) {
    url = url + `?gridType=${type}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateEquityConfig(
  { appraisalService },
  authenticationToken,
  { payload, configID },
) {
  const url = `${appraisalService}/appraisal/comparableequity/configuration/${configID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function insertEquityConfig(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/comparableequity/configuration`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchConfigScoringRulesAll(
  { appraisalService },
  authenticationToken,
  { configID },
) {
  const url = `${appraisalService}/appraisal/comparableequity/configuration/${configID}/scoringrules`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateConfigScoringRule(
  { appraisalService },
  authenticationToken,
  { payload, ruleID },
) {
  const url = `${appraisalService}/appraisal/comparableequity/configuration/scoringrule/${ruleID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function insertConfigScoringRule(
  { appraisalService },
  authenticationToken,
  { configID, payload },
) {
  const url = `${appraisalService}/appraisal/comparableequity/configuration/${configID}/scoringrules`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteConfigScoringRule(
  { appraisalService },
  authenticationToken,
  { ruleID },
) {
  const url = `${appraisalService}/appraisal/comparableequity/configuration/scoringrule/${ruleID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchEquityTierSelectionAll(
  { appraisalService },
  authenticationToken,
  { configID },
) {
  const url = `${appraisalService}/appraisal/comparableequity/configuration/${configID}/tierselections`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateEquityTierSelection(
  { appraisalService },
  authenticationToken,
  { payload, configID, criteriaID },
) {
  const url = `${appraisalService}/appraisal/comparableequity/configuration/${configID}/tierselection/${criteriaID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function insertEquityTierSelection(
  { appraisalService },
  authenticationToken,
  { configID, payload },
) {
  const url = `${appraisalService}/appraisal/comparableequity/configuration/${configID}/tierselections`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteEquityTierSelection(
  { appraisalService },
  authenticationToken,
  { configID, criteriaID },
) {
  const url = `${appraisalService}/appraisal/comparableequity/configuration/${configID}/tierselection/${criteriaID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchEquityScoringFields(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/comparableequity/configuration/scoringfields`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateEquityTierSelectionOrder(
  { appraisalService },
  authenticationToken,
  { payload, configID },
) {
  const url = `${appraisalService}/appraisal/comparableequity/configuration/${configID}/tierselections/reorder`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchSalesConfigAll(
  { appraisalService },
  authenticationToken,
  { type },
) {
  let url = `${appraisalService}/appraisal/comparablesales/configuration`;
  if (type) {
    url = url + `?gridType=${type}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateSalesConfig(
  { appraisalService },
  authenticationToken,
  { payload, configID },
) {
  const url = `${appraisalService}/appraisal/comparablesales/configuration/${configID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function insertSalesConfig(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/comparablesales/configuration`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchSalesConfigScoringRulesAll(
  { appraisalService },
  authenticationToken,
  { configID },
) {
  const url = `${appraisalService}/appraisal/comparablesales/configuration/${configID}/scoringrules`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateSalesConfigScoringRule(
  { appraisalService },
  authenticationToken,
  { payload, ruleID },
) {
  const url = `${appraisalService}/appraisal/comparablesales/configuration/scoringrule/${ruleID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function insertSalesConfigScoringRule(
  { appraisalService },
  authenticationToken,
  { configID, payload },
) {
  const url = `${appraisalService}/appraisal/comparablesales/configuration/${configID}/scoringrules`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteSalesConfigScoringRule(
  { appraisalService },
  authenticationToken,
  { ruleID },
) {
  const url = `${appraisalService}/appraisal/comparablesales/configuration/scoringrule/${ruleID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchSalesTierSelectionAll(
  { appraisalService },
  authenticationToken,
  { configID },
) {
  const url = `${appraisalService}/appraisal/comparablesales/configuration/${configID}/tierselections`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateSalesTierSelection(
  { appraisalService },
  authenticationToken,
  { payload, configID, criteriaID },
) {
  const url = `${appraisalService}/appraisal/comparablesales/configuration/${configID}/tierselection/${criteriaID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function insertSalesTierSelection(
  { appraisalService },
  authenticationToken,
  { configID, payload },
) {
  const url = `${appraisalService}/appraisal/comparablesales/configuration/${configID}/tierselections`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteSalesTierSelection(
  { appraisalService },
  authenticationToken,
  { configID, criteriaID },
) {
  const url = `${appraisalService}/appraisal/comparablesales/configuration/${configID}/tierselection/${criteriaID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchSalesScoringFields(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/comparablesales/configuration/scoringfields`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateSalesTierSelectionOrder(
  { appraisalService },
  authenticationToken,
  { payload, configID },
) {
  const url = `${appraisalService}/appraisal/comparablesales/configuration/${configID}/tierselections/reorder`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function getDropdownValues(
  { appraisalService },
  authenticationToken,
  { endpoint, year, service },
) {
  let url = `${service || appraisalService}${endpoint}`;
  const queryPrefix = url.includes('?') ? '&' : '?';
  url = year ? `${url}${queryPrefix}year=${year}` : url;
  const { body } = await get(authenticationToken, url);
  return body;
}
